export default "__VITE_ASSET__ca07dba8__"